export class TimeWanted {
    ismanualfire: boolean;
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;

    public static Make(date: Date): TimeWanted {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();

        const timeWanted: TimeWanted = {
            ismanualfire: false,
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
        };

        return timeWanted;
    }
}
